.root {
  display: grid;
  width: min(100%, 28rem);
  min-width: 0;
  gap: var(--space-2);
}

.root[data-compact] {
  width: 100%;
}

.meta,
.chapters,
.reward {
  display: flex;
  min-width: 0;
  align-items: center;
}

.meta {
  flex-wrap: wrap;
  gap: var(--space-3);
  font-size: var(--mantine-font-size-sm);
  font-weight: 500;
}

.rewards {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-2) var(--space-3);
}

.rewards:empty {
  display: none;
}

.chapters,
.reward {
  gap: var(--space-2);
  white-space: nowrap;
}

.reward img {
  width: 1.25rem;
  height: 1.25rem;
  flex: none;
}

.reward img {
  object-fit: contain;
}

.meta strong {
  font-weight: inherit;
  font-variant-numeric: tabular-nums;
}

.label,
.separator,
.meta strong:not([data-complete]) .current {
  font-weight: 400;
  opacity: 0.75;
}

.track {
  position: relative;
  height: 0.875rem;
  overflow: hidden;
  border-radius: var(--radius-pill);
  background: color-mix(in srgb, currentColor 30%, transparent);
  box-shadow: inset 0 0.125rem 0.25rem rgb(0 0 0 / 0.12);
}

.track::after {
  position: absolute;
  inset: 0;
  background: repeating-linear-gradient(
    90deg,
    transparent 0,
    transparent calc(var(--segment-size) - 2px),
    rgb(0 0 0 / 0.16) calc(var(--segment-size) - 2px),
    rgb(0 0 0 / 0.16) var(--segment-size)
  );
  content: '';
  pointer-events: none;
}

.track > span {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: var(--gradient-accent);
  box-shadow:
    inset 0 0.125rem 0 rgb(255 255 255 / 0.35),
    0 0 0.5rem rgb(255 196 58 / 0.45);
}
